const carouselItems = [
  {
    title: '玄幻修仙巅峰对决',
    tag: '韩漫热榜',
    excerpt: '修真界风云再起，少年踏上逆天改命之路。百万读者追更，口碑炸裂的年度玄幻大作。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20oriental%20fantasy%20illustration%20with%20a%20young%20warrior%20in%20flowing%20robes%20standing%20on%20a%20mountain%20peak%2C%20glowing%20golden%20energy%20surrounding%20them%2C%20ancient%20Chinese%20temples%20in%20the%20background%2C%20epic%20scale%2C%20warm%20orange%20and%20gold%20tones%2C%20cinematic%20lighting%2C%20anime-inspired%20art%20style%2C%20highly%20detailed%2C%20dramatic%20composition&width=800&height=500&seq=carousel-1-xuanhuan&orientation=landscape',
  },
  {
    title: '恋爱甜宠心动合集',
    tag: '编辑精选',
    excerpt: '高糖预警！从校园到职场，承包你一整年的少女心。画风精致，剧情撩人，每一页都是心动瞬间。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20anime-style%20illustration%20of%20a%20couple%20under%20cherry%20blossom%20trees%20in%20soft%20pastel%20pink%20lighting%2C%20warm%20and%20dreamy%20atmosphere%2C%20sparkling%20petals%20floating%2C%20gentle%20sunset%20glow%2C%20romantic%20manga%20art%20style%2C%20high%20detail%2C%20soft%20focus%20background&width=800&height=500&seq=carousel-2-romance&orientation=landscape',
  },
  {
    title: '国漫原创年度力作',
    tag: '国漫专区',
    excerpt: '国产漫画迎来黄金时代！精选年度最佳原创国漫，画工精湛、剧情扎实，每一部都值得收藏品味。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20ink-painting%20style%20illustration%20blending%20traditional%20aesthetics%20with%20modern%20comic%20art%2C%20a%20heroic%20figure%20with%20flowing%20long%20hair%20in%20dynamic%20pose%2C%20red%20and%20gold%20accents%2C%20dramatic%20brushstroke%20effects%2C%20warm%20atmospheric%20lighting%2C%20epic%20and%20artistic%20composition&width=800&height=500&seq=carousel-3-guoman&orientation=landscape',
  },
  {
    title: '热血格斗燃炸全场',
    tag: '燃向推荐',
    excerpt: '拳拳到肉的战斗场面，绝境逆袭的热血剧情！战斗分镜张力拉满，让你肾上腺素飙升的格斗漫画。',
    image: 'https://readdy.ai/api/search-image?query=A%20high-energy%20dynamic%20action%20anime%20illustration%20with%20two%20fighters%20clashing%20in%20mid-air%2C%20explosive%20energy%20effects%2C%20dramatic%20motion%20lines%2C%20vibrant%20warm%20orange%20and%20red%20color%20palette%2C%20urban%20cityscape%20background%2C%20cinematic%20lighting%2C%20intense%20composition%2C%20shonen%20manga%20art%20style&width=800&height=500&seq=carousel-4-action&orientation=landscape',
  },
  {
    title: '悬疑推理烧脑神作',
    tag: '口碑佳作',
    excerpt: '层层反转的悬疑剧情，烧脑刺激的推理体验。每一话都是智商挑战，伏笔回收让人拍案叫绝。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20mystery%20illustration%20with%20a%20detective%20figure%20in%20a%20dimly%20lit%20room%2C%20shadows%20and%20silhouettes%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20papers%20and%20clues%20scattered%2C%20rain%20on%20window%2C%20noir-inspired%20anime%20art%20style%2C%20moody%20composition%2C%20high%20detail%2C%20suspenseful%20atmosphere&width=800&height=500&seq=carousel-5-mystery&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑部精心挑选的必看好漫</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <div key={item.title} className="group flex flex-col rounded-xl overflow-hidden bg-background-50 cursor-pointer">
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[10px] font-bold whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm font-bold text-foreground-800 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}